import { format } from "date-fns";

import { MetaphoreCollectionSyncLogStatus } from "../../../../generated/gql/graphql";

export function getSyncStatusColor(
  status?: MetaphoreCollectionSyncLogStatus | null
): string {
  switch (status) {
    case MetaphoreCollectionSyncLogStatus.Scheduled:
      return "text-blue-400";
    case MetaphoreCollectionSyncLogStatus.Pending:
      return "text-yellow-400";
    case MetaphoreCollectionSyncLogStatus.Successful:
      return "text-green-400";
    case MetaphoreCollectionSyncLogStatus.Failed:
      return "text-red-400";
    case MetaphoreCollectionSyncLogStatus.Canceled:
      return "text-gray-400";
    case MetaphoreCollectionSyncLogStatus.Skipped:
      return "text-slate-300";
    default:
      return "text-brown-400";
  }
}

export function formatSyncDate(value?: string | null): string {
  if (!value) {
    return "-";
  }
  return format(new Date(value), "dd/MM/yyyy HH:mm");
}
